export const SET_DONE = "loading/SET_DONE"

export const actionSetDone = (isDone) => {
  return {
    type: SET_DONE,
    payload: {
      isDone,
    }
  }
}